import './auto-credit-header.scss';

import { Button } from '@/components/Shared/ui';
import PlusIcon from '@/media/icons/plus.svg?react';
import { useAppDispatch } from '@/store';
import { setNewOrderToInitial } from '@/store/newOrder.slice';

interface IProps {
  onCreateClick: () => void;
}

const AutoCreditHeader: React.FC<IProps> = ({ onCreateClick }) => {
  const dispatch = useAppDispatch();

  return (
    <div className="auto-credit-header">
      <div className="auto-credit-header__title">
        <h2>Заявления</h2>
        <p>Созданные заявки на автокредитование</p>
      </div>
      <div className="auto-credit-header__pagination">
        <Button
          size="big"
          variant="filled-red"
          onClick={() => {
            dispatch(setNewOrderToInitial());
            onCreateClick();
          }}
        >
          Новая заявка
          <PlusIcon />
        </Button>
      </div>
    </div>
  );
};

export default AutoCreditHeader;
